import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Stack } from '@mui/material';

import { Modal } from 'components/Modal';
import { Checkbox, FormProvider } from 'components/Form';

import { useUpdateCompanyPartnerTypes } from '../api/updateCompanyPartnerTypes';

const toFormValues = (partnerTypes) =>
  Object.fromEntries(partnerTypes.map(({ key, selected }) => [key, selected]));

export const PartnerTypesModal = ({ companyId, partnerTypes, open, handleClose, refetch }) => {
  const methods = useForm({ defaultValues: toFormValues(partnerTypes) });
  const { mutateAsync, isLoading } = useUpdateCompanyPartnerTypes(companyId);

  useEffect(() => {
    if (open) {
      methods.reset(toFormValues(partnerTypes));
    }
  }, [open, partnerTypes]);

  const onSubmit = (values) => {
    mutateAsync(partnerTypes.filter(({ key }) => values[key]).map(({ key }) => key))
      .then(() => {
        refetch();
        handleClose();
      })
      .catch((error) => console.log(error));
  };

  return (
    <Modal title="Partner" open={open} handleClose={handleClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack mb={3}>
          {partnerTypes.map(({ key, label }) => (
            <Checkbox key={key} name={key} label={label} />
          ))}
        </Stack>

        <Stack direction="row" gap={3} justifyContent="center">
          <Button variant="outlined" color="primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" type="submit" disabled={isLoading}>
            Update
          </Button>
        </Stack>
      </FormProvider>
    </Modal>
  );
};
